/**
 * Ein Model zur Abbildung eines Filters
 */
class FilterModel {
    /**
     * Die zu filternde Eigenschaft
     */
    name: string;

    /**
     * Der logische Vergleichsoperator
     */
    operator: ComparisonMethod

    /**
     * Der Filterwert
     */
    value: any;

    /**
     * Der Gültigkeitsbereich des Filters
     */
    scope: ClientScope = "component";

    /**
     * C'tor
     *
     * @param options - Die Initialisierungsoptionen
     * @param options.name - Der Name des Filters
     * @param options.value - Der Filterwert
     * @param options.operator - Der logische Vergleichsoperator
     * @param options.scope - Der Gültigkeitsbereich des Filters
     */
    constructor({ name, value = null, operator = "equals", scope = "component"}:{name: string, value: any, operator?: ComparisonMethod, scope?: ClientScope}) {
        this.name = name;
        this.operator = operator;
        this.scope = scope;
        this.value = value;
    }

    /**
     * Erzeugt ein Key-Value-Paar aus {@linkcode name} und {@linkcode value}
     *
     * @returns {{}} Das Key-Value-Paar
     */
    toJson():{[key: string]: any} {
        const json:{[key: string]: any} = {};

        json[this.name] = this.value;

        return json;
    }
}

export default FilterModel;
